import React, { createContext, FC } from 'react'

import { ButtonGroupProps } from '@pijma/hero-types'

import { css } from '@emotion/css'

export const ButtonGroupContext = createContext({
  active: false,
  stretch: false,
})
export const ButtonGroup: FC<ButtonGroupProps> = ({
  stretch = false,
  children,
}) => {
  const styles = css({
    container: 'button-group /inline-size',
    display: stretch ? 'flex' : 'inline-flex',
    justifyContent: stretch ? 'stretch' : 'flex-start',
  })

  return (
    <ButtonGroupContext.Provider value={{ active: true, stretch: !!stretch }}>
      <div className={styles}>{children}</div>
    </ButtonGroupContext.Provider>
  )
}

ButtonGroup.displayName = 'ButtonGroup'
